import icon from 'vue-svgicon';

icon.register({
    'bold/alert-circle': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M11.983 0a12.206 12.206 0 0 0-8.51 3.653A11.8 11.8 0 0 0 0 12.207 11.779 11.779 0 0 0 11.8 24h.214A12.111 12.111 0 0 0 24 11.791 11.766 11.766 0 0 0 11.983 0zM10.5 16.542a1.476 1.476 0 0 1 1.449-1.53h.027a1.527 1.527 0 0 1 1.523 1.47 1.475 1.475 0 0 1-1.449 1.53h-.027a1.529 1.529 0 0 1-1.523-1.47zM11 12.5v-6a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0z"/>`,
    },
});
